// Intercept all fetch calls to /cart/add and block unauthorized ones
(function() {
  const originalFetch = window.fetch;
  window.CBI_ALLOWED_ADD_TO_CART = false;
  
  window.fetch = function(...args) {
    const url = args[0];
    const urlString = typeof url === 'string' ? url : url.url;
    
    // Check if this is a cart add request
    if (urlString && (urlString.includes('/cart/add.js') || urlString.includes('/cart/add'))) {
      // Only allow if our custom handler set the flag
      if (!window.CBI_ALLOWED_ADD_TO_CART) {
        // Return a fake successful response to prevent errors
        return Promise.resolve(new Response(JSON.stringify({ok: true}), {
          status: 200,
          headers: {'Content-Type': 'application/json'}
        }));
      }
      
      // Reset flag after allowing
      window.CBI_ALLOWED_ADD_TO_CART = false;
    }
    
    return originalFetch.apply(this, args);
  };
})();

function decrementValueOnItem(item, step=1) {
  if (parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) > step) {
    item.parentNode.querySelectorAll("input[type=text]")[0].value = (
      parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) - step
    ).toString();
  }
}

function incrementValueOnItem(item, step=1) {
  item.parentNode.querySelectorAll("input[type=text]")[0].value = (
    parseInt(item.parentNode.querySelectorAll("input[type=text]")[0].value) + step
  ).toString();
}

function updateCartCounter(quantity) {
  const cartCounter = document.getElementById('cart-counter');
  if (quantity > 0) {
    cartCounter.classList.remove("hidden");
    cartCounter.classList.add("flex");
  } else {
    cartCounter.classList.add("hidden");
  }
  cartCounter.innerHTML = quantity;
}


function appendAddOpenCartToAddToCartBtns(arr) {
  
  for (let i=0;i<arr.length;i++) {
    const element = arr[i]
    let varId = element.dataset.id || element.dataset.variantId
    

    // Prevent duplicate handlers (EComposer cloneNode protection)
    if (!element.hasAttribute('data-cart-handler-added')) {
      element.setAttribute('data-cart-handler-added', 'true');
      
      element.addEventListener("click", function(e) {        
        e.preventDefault();
        e.stopPropagation();
        
        const form = element.closest('form');
        const quantityInput = form ? form.querySelector('#quantity') : null;
        
        
        const quantity = quantityInput && quantityInput.value ? parseInt(quantityInput.value) || 1 : 1;
        
        handleAddToCart(quantity, varId)
      })
    } else {
      console.log('Skipped button', i, '- already has handler');
    }
  }
} 

window.onload = function() {
  const addcartbtns = document.querySelectorAll('[data-text-added-cart]')
  
  if (addcartbtns) {
    appendAddOpenCartToAddToCartBtns(addcartbtns);
  }
};

// Function to handle cart hash detection and opening
function handleCartHash() {
  if (window.location.hash === "#cart") {
    // Check if CBI cart is enabled, otherwise use Bloom
    if (window.CBI_CART_PANEL_ENABLED !== false) {
      // Use the existing showCBICart function from cbi_cart.js
      if (typeof showCBICart === "function") {
        showCBICart();
      }
    } else {
      // Fall back to Bloom cart if CBI cart is disabled
      if (window.bloom && typeof bloom.showCart === "function") {
        bloom.showCart();
      }
    }
  }
}

// Check for cart hash on page load
document.addEventListener("DOMContentLoaded", function () {
  handleCartHash();
});

// Listen for hash changes (when user navigates to /#cart)
window.addEventListener("hashchange", function () {
  handleCartHash();
});
